import React, {useEffect, useState} from "react";
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {getStatusLabel, getTransicoes} from "../licencasUtils";

// Mudança de situação da licença (BBF-3): só os destinos que a tabela de transições permite, e
// motivo obrigatório, que vai para o histórico da licença junto com quem pediu.
export default function SituacaoDialog({open, licenca, saving, erro, onClose, onConfirm}) {
    const [para, setPara] = useState('');
    const [motivo, setMotivo] = useState('');
    const destinos = getTransicoes(licenca?.status);

    useEffect(() => {
        if (!open) return;
        setPara(getTransicoes(licenca?.status)[0] || '');
        setMotivo('');
    }, [open, licenca?.id, licenca?.status]);

    const podeConfirmar = destinos.includes(para) && Boolean(motivo.trim()) && !saving;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Mudar situação</DialogTitle>
            <DialogContent>
                <Stack spacing={2.5} sx={{pt: 1}}>
                    <Typography variant="body2" color="text.secondary">
                        Situação atual: <strong>{getStatusLabel(licenca?.status)}</strong>
                    </Typography>
                    <TextField
                        select
                        label="Nova situação"
                        value={destinos.includes(para) ? para : ''}
                        onChange={(event) => setPara(event.target.value)}
                        fullWidth
                        disabled={!destinos.length}
                        helperText={destinos.length ? null : 'Esta situação não tem para onde ir.'}
                    >
                        {destinos.map((status) => (
                            <MenuItem key={status} value={status}>{getStatusLabel(status)}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Motivo"
                        value={motivo}
                        onChange={(event) => setMotivo(event.target.value)}
                        fullWidth
                        required
                        multiline
                        minRows={2}
                        helperText="Fica no histórico da licença, com quem fez a mudança."
                    />
                    {erro ? <Alert severity="error">{erro}</Alert> : null}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" disabled={!podeConfirmar} onClick={() => onConfirm(para, motivo.trim())}>
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
